<div class="image-container" [ngStyle]="{ height: imageContainerHeight }">
  <div
    *ngFor="let item of categoryData; trackBy: trackByItems; let i = index"
    (click)="makeActive(i)"
    class="image-item"
    [ngClass]="{ 'slide-out': getPosition(i) === categoryData.length - 1 }"
    [ngStyle]="{
      width: imageItemWidth,
      transform: 'translateX(' + getPosition(i) * 108 + '%)',
      height: i === activeIndex ? '100%' : '80%',
      top: i === activeIndex ? '0%' : '10%'
    }"
  >
    <img [src]="item.image" [alt]="item.name" />
    <div class="slide-title">{{ item.name }}</div>
  </div>
</div>
